import Icon from '../components/Icon.vue'

Icon.register({
  link: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M326.6 185.4C386.4 245.2 385.5 341.1 327 400 326.9 400.1 326.7 400.2 326.6 400.4L259.4 467.6C200.1 526.8 103.7 526.8 44.5 467.6-14.8 408.3-14.8 311.9 44.5 252.6L81.6 215.5C91.4 205.6 108.3 212.2 108.9 226.1 109.5 243.8 112.7 261.6 118.5 278.8 120.5 284.6 119.1 291.1 114.8 295.4L101.7 308.5C73.6 336.5 72.8 382.2 100.5 410.5 128.5 439.1 174.6 439.2 202.8 411L270 343.8C298.2 315.6 298.1 270 270 242 266.3 238.3 262.6 235.4 259.7 233.4A16-16 0 0 0 252.8 220.8C252.4 210.2 256.1 199.3 264.5 191L285.5 169.9C291 164.4 299.7 163.7 306.1 168.2A152.5-152.5 0 0 0 326.6 185.4zM467.5 44.4C408.3-14.8 311.9-14.8 252.6 44.4L185.4 111.6C185.3 111.8 185.1 111.9 185 112 126.5 170.9 125.6 266.8 185.4 326.6A152.5-152.5 0 0 1 205.9 343.8C212.3 348.3 221 347.6 226.5 342.1L247.5 321C255.9 312.7 259.6 301.8 259.2 291.2A16-16 0 0 1 252.3 278.6C249.4 276.6 245.7 273.7 242 270 213.9 242 213.8 196.4 242 168.2L309.2 101C337.4 72.8 383.5 72.9 411.5 101.5 439.2 129.8 438.4 175.5 410.3 203.5L397.2 216.6C392.9 220.9 391.5 227.4 393.5 233.2 399.3 250.4 402.5 268.2 403.1 285.9 403.7 299.8 420.6 306.4 430.4 296.5L467.5 259.4C526.8 200.1 526.8 103.7 467.5 44.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/link.js
// module id = vwXs
// module chunks = 144